module.exports = __webpack_public_path__ + "static/media/the-lab4.86200f1b.jpg";